import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "GdLabsModule"
const debug = false

export class GdLabsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.GD_LABS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "GD Labs"

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.description                = ""
        this.svgIcon                    = "isvg-gd-labs"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "System"
        this.settingsUrl                = "settings/gd-labs"
        this.parentSection              = SettingsParentSection.SYSTEM

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}